import { useState } from "react";
import { Check, ClipboardCopy } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export const CopyButton = ({ text, label = "Copy", testId, size = "sm", variant = "outline" }) => {
  const [copied, setCopied] = useState(false);
  const doCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      toast.success("Copied to clipboard");
      setTimeout(() => setCopied(false), 1800);
    } catch {
      toast.error("Could not copy — please select and copy manually");
    }
  };
  return (
    <Button type="button" size={size} variant={variant} onClick={doCopy} data-testid={testId}>
      {copied ? <Check className="h-4 w-4 mr-1.5" /> : <ClipboardCopy className="h-4 w-4 mr-1.5" />}
      {copied ? "Copied" : label}
    </Button>
  );
};
